import { useCallback } from 'react'
import { observer } from 'mobx-react'
import { AccordionProps } from '@material-ui/core'
import Introduction, {
  IntroductionStylesVariant
} from 'components/Introduction'
import { trackInAmplitude } from 'utils/tracking/amplitude'
import {
  AmplitudeEvent,
  InformationElement
} from '../../utils/tracking/amplitude/amplitude.interface'

type Props = {
  path: string
  children?: AccordionProps['children']
  opened?: boolean
  title?: string
  headline?: string
  info?: string
  stylesVariant?: IntroductionStylesVariant
}

export interface PathStyleProps {
  withAlternativeTitle?: boolean
  withHeadline?: boolean
  useInfoAlternativeIfAvailable?: boolean
}

export const introductionDefaultProps = {
  pathStyleProps: {
    withHeadline: true
  },
  introductionStyleProps: {}
}

const PathIntroduction = observer(
  ({
    path,
    children,
    opened = false,
    title,
    headline,
    info,
    stylesVariant
  }: Props) => {
    const onChange = useCallback(
      (isVisible: boolean) => {
        trackInAmplitude(AmplitudeEvent.ToggleInformation, {
          path,
          type: InformationElement.IntroText,
          isVisible
        })
      },
      [path]
    )

    return (
      <Introduction
        onChange={onChange}
        id={path}
        title={title}
        expanded={opened}
        headline={headline}
        info={info}
        stylesVariant={
          stylesVariant || IntroductionStylesVariant.GreyBackground
        }
      >
        {children}
      </Introduction>
    )
  }
)

export default PathIntroduction
